import React, { useMemo } from 'react'

import { useFilters, useModals, useSetState } from '@domain-group/react-hooks'

import { ModalContext } from '@domain-group/suit-theme'

import PageContext from '@contexts/pageContext'

import handleCallbackAction from '@functions/handleCallbackAction'

import CreatePublicationModal from '@modals/CreatePublicationModal'

import PageContent from './components/PageContent'

const callbacks = (component, setState) => {
  const componentCallbacks = {
    CreatePublicationModal: {
      closeModal: () => setState({ showCreatePublicationModal: false }),
      createPublication: payload => handleCallbackAction(payload),
    },
  }

  return componentCallbacks[component] || {}
}

const defaultState = {
  showCreatePublicationModal: false,
}

const List = () => {
  const [state, setState] = useSetState(defaultState)
  const { showCreatePublicationModal } = state

  const {
    callbacks: filterCallbacks,
    defaultFilters,
    pageFilters,
  } = useFilters()

  const modalContext = useModals({ setState })

  const pageContext = useMemo(() => ({
    callbacks: {
      ...filterCallbacks,
      showCreatePublicationModal: () => setState({ showCreatePublicationModal: true }),
    },
    defaultFilters,
  }), [])

  return (
    <PageContext.Provider value={pageContext}>
      <ModalContext.Provider value={modalContext}>
        <PageContent pageFilters={pageFilters} />

        <CreatePublicationModal
          callbacks={callbacks('CreatePublicationModal', setState)}
          showModal={showCreatePublicationModal}
        />
      </ModalContext.Provider>

    </PageContext.Provider>
  )
}

export default List
